export type CircleButtonProps = {
  backgroundColor?: BackgroundColorCircleButtonEnum;
  className?: string;
  icon: React.ReactNode;
  onClick?: () => void;
  text?: string;
  textColor?: string;
}

export enum BackgroundColorCircleButtonEnum {
  CLASSIC_RED = 'bg-classic-red-main',
  ADMIN_BLUE = 'bg-admin-blue-main',
}

export enum TextColorCircleButtonEnum {
  BLACK = 'text-black',
  WHITE = 'text-white',
}


const CircleButton = ({ 
  backgroundColor = BackgroundColorCircleButtonEnum.ADMIN_BLUE,
  className,
  icon,
  onClick,
  text,
  textColor = TextColorCircleButtonEnum.BLACK
}: CircleButtonProps): JSX.Element => {
  return (
    <button className={`m-0 flex flex-col gap-05v items-center ${className}`} onClick={onClick}>
      <div className={`p-1w rounded-full text-white ${backgroundColor}`} >
        {icon}
      </div>
      <p className={`text-center text-overline ${textColor}`}>{text}</p>
    </button>
  );
}

export default CircleButton;